const ABILITY_TYPE_MAP = {
  'Çelik Yolu': 'abilityBedensel',
  'Demir İrade': 'abilityZihinsel',
  'Kül Yolu': 'abilityKaraBuyu',
  'Tılsımlı Kılıç': 'abilityBuyuluSilah',
};

const CHARACTER_ID_MAP = {
  1: 'characters1',
  2: 'characters2',
};

export function translateCharacterName(t, id, fallback) {
  const key = CHARACTER_ID_MAP[id];
  if (key) {
    return t(`${key}Name`, { ns: 'gameData', defaultValue: fallback });
  }
  if (fallback === 'Alp') return t('characterWarrior', { ns: 'gameData', defaultValue: fallback });
  if (fallback === 'Kara Alp') return t('characterSura', { ns: 'gameData', defaultValue: fallback });
  return fallback;
}

export function translateCharacterDescription(t, id, fallback) {
  const key = CHARACTER_ID_MAP[id];
  if (key) {
    return t(`${key}Desc`, { ns: 'gameData', defaultValue: fallback });
  }
  return fallback;
}

export function translateAbilityTypeName(t, fallback) {
  const key = ABILITY_TYPE_MAP[fallback];
  if (key) {
    return t(key, { ns: 'gameData', defaultValue: fallback });
  }
  return fallback;
}

export function translateVillageName(t, fallback) {
  return t(`villages.${fallback}`, { ns: 'gameData', defaultValue: fallback });
}

export function translateNpcType(t, npcType) {
  const map = {
    blacksmith: 'npcBlacksmith',
    demirci: 'npcBlacksmith',
    market: 'npcMarket',
    weapon_dealer: 'npcWeaponDealer',
    silahci: 'npcWeaponDealer',
    armorer: 'npcArmorer',
    zirhci: 'npcArmorer',
    fisher: 'npcFisher',
    balikci: 'npcFisher',
    miner: 'npcMiner',
    madenci: 'npcMiner',
    gardener: 'npcGardener',
    bahcivan: 'npcGardener',
    farmer: 'npcFarmer',
    ciftci: 'npcFarmer',
  };
  const key = map[npcType];
  if (key) {
    return t(key, { ns: 'village', defaultValue: npcType });
  }
  return npcType;
}

export function translateCharacterBadge(t, characterId) {
  if (characterId === 0) return t('badgeAllCharacters', { ns: 'village' });
  if (characterId === 1) return t('badgeWarrior', { ns: 'village' });
  if (characterId === 2) return t('badgeSura', { ns: 'village' });
  return t('characterUnknown', { ns: 'gameData' });
}

export function translateGameEntity(t, category, id, fallback) {
  if (!fallback && !id) return '';
  return t(`${category}.${id}`, { ns: 'gameData', defaultValue: fallback || '' });
}
